<template>
  <div class="footer  media-footer-height">
    <div :key="`toolbox_${i}`" class="item" v-for="(m,i) in toolMenus" @click="changePage(m,i)">
      <div>
        <img :src="m.isActive?m.activeSrc:m.src" style=""/>
      </div>
      <div class="offset-top">
        <span :active="m.isActive&&true" v-text="m.text"></span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'Toolbox',
  data() {
    return {}
  },
  computed: {
    ...mapState(['toolMenus'])
  },
  methods: {
    changePage(menu) {
      this.$router.push({ name: menu.name })
    }
  }
}
</script>

<style scoped lang="less">
@import "../assets/less/base";

.footer {
  width: 100%;
  height: 48px;
  position: fixed;
  left: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: @base-white;
  .item {
    cursor: pointer;
    min-width: 110px;
    .text-center;
    img {
      height: 23px
    }
    span {
      font-size: 10px;
      color: #B7BBBF;
    }
    span[active] {
      color: @base-color;
    }
    .offset-top {
      margin-top: -8px;
    }
  }
}
</style>
